export class PromiseHelper {
    constructor() {
        this.promiseMap = {};
    }

    getPromise(key) {
        return this.promiseMap[key];
    }

    putPromise(key, value) {
        this.promiseMap[key] = value;
    }

    removePromise(key) {
        delete this.promiseMap[key];
    }
}

export class Counter {
    constructor() {
        this.counts = {};
    }

    getCount(key) {
        return this.counts[key] || 0;
    }

    setCount(key, value) {
        this.counts[key] = value;
    }

    incrementByOne(key) {
        const value = this.getCount(key);
        this.setCount(key, value + 1);
    }

    decrementByOne(key) {
        const value = this.getCount(key);
        this.setCount(key, value - 1);
    }
}
